export function isPrizeToKeepForWinner(search: string | undefined, item: any) {
    const s = (search || '').trim().toLowerCase();
    return !![item.ticketCode, item.ticketCustomCode, item.lastName, item.firstName, item.email, item.phone]
        .filter((x) => !!x)
        .find((x) => x.toLowerCase().slice(0, s.length) === s);
}

export default isPrizeToKeepForWinner;
